import React, { useState, useEffect } from 'react';
import type { Category } from '../../types';
import { readChannelAvailability } from '../../lib/menuChannelAvailability';
import MenuChannelAvailabilityFields from './MenuChannelAvailabilityFields';

interface CategoryModalProps {
  category: Category | null;
  onClose: () => void;
  onSave: (category: Category) => void;
}

const CategoryModal: React.FC<CategoryModalProps> = ({ category, onClose, onSave }) => {
  const [name, setName] = useState('');
  const [id, setId] = useState<number | string | null>(null);
  const [channelAvailability, setChannelAvailability] = useState(readChannelAvailability(undefined));

  useEffect(() => {
    if (category) {
      setName(category.name);
      setId(category.id);
      setChannelAvailability(readChannelAvailability(category));
    } else {
      setName('');
      setId(null);
      setChannelAvailability(readChannelAvailability(undefined));
    }
  }, [category]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) {
        alert('Please provide a category name.');
        return;
    }
    onSave({ name, id: id || 0, ...channelAvailability });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4">
      <div className="bg-white rounded-lg shadow-xl p-8 w-full max-w-md max-h-[90vh] overflow-y-auto">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">{category ? 'Edit Category' : 'Add New Category'}</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">Category Name</label>
            <input 
              type="text" 
              name="name" 
              id="name" 
              value={name} 
              onChange={(e) => setName(e.target.value)} 
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-gray-100 text-gray-900 focus:outline-none focus:ring-pink-500 focus:border-pink-500" 
              required 
              autoFocus
            />
          </div>
          <MenuChannelAvailabilityFields
            value={channelAvailability}
            onChange={setChannelAvailability}
            helperText="Applies to every item in this category. Leave only Meal plan checked to keep the category off the till and online menus."
          />
          <div className="flex justify-end space-x-4">
            <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300">Cancel</button>
            <button type="submit" className="px-4 py-2 bg-pink-500 text-white rounded-md hover:bg-pink-600">Save Category</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CategoryModal;
